import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string) {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

async function apiFetch<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = Cookies.get('token')
  const headers: Record<string, string> = {}
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  if (token) headers.Authorization = `Bearer ${token}`
  const res = await fetch(buildUrl(path), {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })
  if (!res.ok) {
    if (res.status === 401 && token) {
      handleSessionExpired()
      throw new Error('Session expired')
    }
    const p = await res.json().catch(() => null)
    throw new Error(p?.error?.message || p?.message || res.statusText || 'Request failed')
  }
  if (res.status === 204) return undefined as T
  return res.json()
}

export function getPushPublicKey(): Promise<{ data: { publicKey: string | null; configured: boolean } }> {
  return apiFetch('GET', '/api/notifications/push-public-key')
}

export function subscribeToPush(subscription: {
  endpoint: string
  keys: { p256dh: string; auth: string }
  userAgent?: string
}): Promise<void> {
  return apiFetch('POST', '/api/notifications/push-subscriptions', subscription)
}

export function unsubscribeFromPush(endpoint: string): Promise<void> {
  return apiFetch('DELETE', '/api/notifications/push-subscriptions', { endpoint })
}
